/* eslint-disable global-require */
import React, { useEffect, useState, Suspense, lazy, useContext } from 'react';
import { useForm } from 'react-hook-form';
import { Image, Row, Col } from 'react-bootstrap';
import { Label } from 'reactstrap';
import Popup from 'reactjs-popup';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare } from '@fortawesome/free-regular-svg-icons';
import { faArrowUpFromBracket, faUserXmark } from '@fortawesome/free-solid-svg-icons';
import { SpinnerDotted } from 'spinners-react';
import { useDispatch } from 'react-redux';
import axios from 'axios';
import { toast } from 'react-toastify';
import { TableContext } from '../../contexts/tableContext';
import styles from './settings.module.scss';
import { Entry } from '../../redux/entrySlice';
import envValues from '../../enviornment';
import { getCookies, setCookies } from '../../hooks/useCookies';

const EmailInput = lazy(() => import('../../components/EmailBox/EmailBox'));
const TextInput = lazy(() => import('../../components/TextField/TextField'));

function Settings() {
  const [submiting, setSubmitting] = useState(false);
  const dispatch = useDispatch();
  const { formthemeStyle, setSiteSettings } = useContext(TableContext);
  const { setDashboardHeader } = useContext(TableContext);
  const { settingsgeneralSetStyle, settingsapiSetStyle, settingsprefSetStyle, settingsprofileSetStyle, settingschangepassSetStyle } =
    useContext(TableContext);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();
  // eslint-disable-next-line no-unused-vars
  const [settingsData, setSettingsData] = useState([]);
  const { bodyheader } = useContext(TableContext);
  const [loader, setLoader] = useState(false);
  const imageupload = (files) => {
    setLoader(true);
    const headers = {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'multipart/form-data',
    };
    const formData = new FormData();
    formData.append('File', files);
    axios
      .post(`${envValues.REACT_APP_API_ENDPOINT}/settings/logo`, formData, [headers])
      .then((response) => {
        setLoader(false);
        if (response.status === 200) {
          toast.success('Logo Updated Successfully');
          const updated = response.data.data.settings;
          setSettingsData(updated);
          setCookies('SITE_SETTINGS', JSON.stringify(updated));
          setSiteSettings({ logo: updated.logo, siteName: updated.values?.sitename || 'SafeSea', tagline: updated.values?.tagline || '' });
        }
        return response.data;
      })
      .catch((e) => e);
  };
  const removePic = () => {
    setLoader(true);
    const headers = {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'multipart/form-data',
    };
    const body = {
      logo: 'https://boilerplate-armia.s3.amazonaws.com/downloads/r512ndohjf0.png-1653567387848',
    };
    axios
      .post(`${envValues.REACT_APP_API_ENDPOINT}/settings/logoremove`, body, [headers])
      .then((response) => {
        setLoader(false);
        if (response.status === 200) {
          const updated = response.data.data.settings;
          setSettingsData(updated);
          setCookies('SITE_SETTINGS', JSON.stringify(updated));
          setSiteSettings({ logo: updated.logo, siteName: updated.values?.sitename || 'SafeSea', tagline: updated.values?.tagline || '' });
          toast.success('Logo Updated Successfully');
        }
        return response.data;
      })
      .catch((e) => e);
  };
  const getSettings = () => {
    const data = {
      actionUrl: 'settings',
      actionMethod: 'get',
    };
    dispatch(Entry(data)).then((resp) => {
      setSettingsData(resp.payload[0]);
      reset(resp.payload[0].values);
    });
  };
  useEffect(() => {
    getSettings();
    setDashboardHeader('Settings');
    settingsgeneralSetStyle('settingsgeneral');
    settingsapiSetStyle('settingslinks');
    settingsprefSetStyle('settingslinks');
    settingsprofileSetStyle('settingslinks');
    settingschangepassSetStyle('settingslinks');
  }, []);
  const onSubmit = (data) => {
    setSubmitting(true);
    const updationData = {
      values: {
        sitename: data.sitename,
        tagline: data.tagline,
      },
    };
    data.actionUrl = 'settings/general';
    data.actionMethod = 'patch';
    data.apiData = updationData;
    dispatch(Entry(data)).then((resp) => {
      setSubmitting(false);
      if (resp.payload) {
        setSiteSettings({
          logo: settingsData.logo || '',
          siteName: data.sitename || 'SafeSea',
          tagline: data.tagline || '',
        });
        const cookie = getCookies('SITE_SETTINGS');
        const parsed = typeof cookie === 'string' ? JSON.parse(cookie) : cookie;
        if (parsed) {
          parsed.values = { ...parsed.values, sitename: data.sitename, tagline: data.tagline };
          setCookies('SITE_SETTINGS', JSON.stringify(parsed));
        }
        toast.success('Settings updated successfully');
      }
    });
  };
  const imageHandler = (e) => {
    const reader = new FileReader();
    reader.onload = () => {
      if (reader.readyState === 2) {
        // setImg(reader.result);
        const files = e.target.files[0];
        imageupload(files);
      }
    };
    reader.readAsDataURL(e.target.files[0]);
  };
  return loader ? (
    <>
      <br />
      <SpinnerDotted style={{ marginTop: '250px', marginLeft: '300px', color: '#39979d' }} />
    </>
  ) : (
    <div>
      {Object.keys(settingsData.values).length !== 0 ? (
        <div className={styles[formthemeStyle]} id={styles.addform}>
          <div className={styles.logoWrapper}>
            <Image src={settingsData.logo} className={styles.logo} alt="Site logo" />
            <Popup
              trigger={
                <div className={styles.editbtnsection}>
                  <FontAwesomeIcon
                    icon={faPenToSquare}
                    className={styles[bodyheader]}
                    id={styles.penicon}
                  />
                </div>
              }
              position="bottom left"
            >
              <div className={styles.upload}>
                <Label htmlFor="input">
                  <FontAwesomeIcon
                    name="image upload"
                    onChange={imageHandler}
                    icon={faArrowUpFromBracket}
                    className={styles.uploadicon}
                  />
                </Label>
                <input
                  id="input"
                  type="file"
                  name="image upload"
                  style={{ display: 'none' }}
                  accept="image/*"
                  placeholder="Update New Pic"
                  onChange={imageHandler}
                />
                <FontAwesomeIcon
                  onClick={removePic}
                  icon={faUserXmark}
                  className={styles.crossicon}
                />
              </div>
            </Popup>
          </div>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Row className="mt-3">
              <Col md={4} sm={4}>
                <Suspense
                  fallback={
                    <div>
                      <SpinnerDotted style={{ color: '#39979d' }} />
                    </div>
                  }
                >
                  <TextInput
                    className={styles.inputbox}
                    classNamedark={styles.inputbox1}
                    fieldName="sitename"
                    label="Site Name"
                    labelstyle={styles.formlabel}
                    register={register}
                    errors={errors}
                    placeHolder="Enter First Name"
                    isRequired
                    maximLength={20}
                    minimLength={3}
                  />
                </Suspense>
              </Col>
            </Row>
            <Row>
              <Col md={4} sm={4}>
                <Suspense
                  fallback={
                    <div>
                      <SpinnerDotted style={{ color: '#39979d' }} />
                    </div>
                  }
                >
                  <TextInput
                    className={styles.inputbox}
                    classNamedark={styles.inputbox1}
                    fieldName="tagline"
                    label="Tagline"
                    labelstyle={styles.formlabel}
                    register={register}
                    errors={errors}
                    placeHolder="Enter tagline"
                    isRequired={false}
                    maximLength={50}
                    minimLength={0}
                  />
                </Suspense>
              </Col>
            </Row>
            <div className={styles.savebtnsection}>
              <input
                className={styles.savebtn}
                type="submit"
                value={submiting ? 'Please wait..' : 'Save Changes'}
              />
            </div>
          </form>
        </div>
      ) : (
        <div style={{ textAlign: 'center', marginTop: '160px', color: '#7a68c2' }}>
          <SpinnerDotted style={{ color: '#39979d' }} />
        </div>
      )}
    </div>
  );
}

export default Settings;
